module.exports = __webpack_public_path__ + "static/Image19@2x-311388291db916e221f43af1d7f27e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image19@2x.jpg
// module id = 912
// module chunks = 227233210825294 244429959259914